import { createStyles, InputStylesNames } from '@mantine/core';

import COLORS_FLAT from '@styles/colors/themes/beam/beam-flat';
import TYPOGRAPHY_FLAT from '@styles/fonts/fontsizes/typography-flat';

interface TextInputStylesParams {
  // From InputStylesParams
  rightSectionWidth?: string | number;
  iconWidth?: string | number;
}

const defaultParams = {
  rightSectionWidth: 15,
  iconWidth: 15,
};
type StyleNames = InputStylesNames | 'label';
export const useInputStyles = createStyles<StyleNames, TextInputStylesParams>(
  (_, params) => {
    return {
      input: {
        borderRadius: 8,
        borderColor: COLORS_FLAT.n400,
        height: 'unset',
        paddingTop: 9,
        paddingBottom: 9,
        paddingLeft: params.iconWidth ?? defaultParams.iconWidth,
        paddingRight:
          params.rightSectionWidth ?? defaultParams.rightSectionWidth,
        '&::placeholder': {
          color: COLORS_FLAT.n600,
        },
        ...TYPOGRAPHY_FLAT.p200,
      },
      disabled: {
        '&:disabled': {
          borderColor: COLORS_FLAT.n300,
          backgroundColor: COLORS_FLAT.n100,
          color: COLORS_FLAT.n600,
          opacity: 1,
        },
        '&:disabled::placeholder': {
          color: COLORS_FLAT.n600,
        },
      },
      label: {
        ...TYPOGRAPHY_FLAT.h300,
        color: COLORS_FLAT.n800,
        marginBottom: 8,
      },
      icon: {
        color: COLORS_FLAT.n600,
        '[data-disabled]': {
          color: COLORS_FLAT.n500,
        },
      },
      wrapper: {},
      withIcon: {},
      invalid: {},
      rightSection: {},
      root: {},
    };
  },
);
